<template>
  <div class="uploadResults">
    <div class="modal-header">
      <div class="entity-title">{{ $t('sftp.uploadTitle') }}</div>
    </div> 
    <div class="content">
      <label>
        {{ $t('sftp.host') }}
        <input v-model="sftpSettings.Host" type="text" placeholder="host">
      </label>
      <label>
        {{ $t('sftp.username') }}
        <input v-model="sftpSettings.Username" type="text" placeholder="naam">
      </label>
      <label>
        {{ $t('sftp.password') }}
        <input v-model="sftpSettings.Password" type="text" placeholder="wachtwoord">
      </label>
      <label>
        {{ $t('sftp.targetLocation') }}
        <input v-model="sftpSettings.TargetLocation" type="text" placeholder="locatie op ftp server">
      </label>
    </div>
    <ul v-if="okClicked">
      <li v-if="sftpSettings.Host == ''">
        <font-awesome-icon class="text-red" icon="times"/>
        {{ $t('sftp.noHost') }}
      </li>
      <li v-if="sftpSettings.Username == ''">
        <font-awesome-icon class="text-red" icon="times"/>
        {{ $t('sftp.noUser') }}
      </li>
      <li v-if="sftpSettings.TargetLocation == ''">
        <font-awesome-icon class="text-red" icon="times"/>
        {{ $t('sftp.noTargetLocation') }}
      </li>
    </ul>
    <div class="statusMessage w3-panel errorBox w3-round" v-show="showStatusMessage">{{ statusMessage }}</div>
    <div class="statusMessage w3-panel errorBox w3-round" v-show="errorMessage != ''">
      <font-awesome-icon class="text-red w3-right" icon="times"/>{{errorMessage }}
      </div>
    <div class="buttons">
      <button :class="{'button-inactive': uploadingInProgress || !enoughUserInput, 'button-default': !uploadingInProgress && enoughUserInput}" @click="ok">{{ $t('app.actions.upload') }}</button>
      <button class="button-default" @click="close">{{ $t('app.actions.cancel') }}</button>
    </div>
  </div>
</template>


<script>

import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const path = '/tournament/';

export default {
  name: "UploadStaticFilesModal",
  data: function () {
    return {
      errorMessage: "",
      interval: null,
      reasons: [{reasonId:"1", name:"absent with message"},
                {reasonId:"2", name:"absent without message"},
                {reasonId:"3", name:"absent for club"},
                {reasonId:"4", name:"manual bye"}],
      selectedAbsenceId: "-1",
      selectedReasonId: "-1",
      sftpSettings: {Host:"", Username:"", Password:"", TargetLocation:""},
      showStatusMessage: false,
      statusMessage: "",
      okClicked: false,
      uploading: false
    }
  },
  beforeMount() {
    this.sftpSettings.Host = localStorage.getItem("sftpHost");
    this.sftpSettings.Username = localStorage.getItem("sftpUser");
    this.sftpSettings.TargetLocation = localStorage.getItem("sftpTargetLocation");
  },
  computed: {
    uploadingInProgress: function () {
      return this.uploading;
    },
    enoughUserInput: function () {
      return this.sftpSettings.Host != "" && this.sftpSettings.Username != "" && this.sftpSettings.TargetLocation != "";
    }
  },
  emits: [ 'cancel', 'ok' ],
  methods: {
    close() {
      this.uploading = false;
      clearInterval(this.interval); 
      this.$emit('cancel');
    },

    ok() {
      this.okClicked = true;
      localStorage.setItem("sftpHost", this.sftpSettings.Host);
      localStorage.setItem("sftpUser", this.sftpSettings.Username);
      localStorage.setItem("sftpTargetLocation", this.sftpSettings.TargetLocation);
      this.createStaticFiles();
    },

    getStaticStatus() {
      if (this.uploading) {
        let completePath = path + this.$route.params.tournamentId + "/staticStatus"
        const localInit = { 
          response: true,
        };
        RestAPI
          .get(apiName, completePath, localInit)
          .then(response => {
            this.statusMessage = response.data.message;
            console.log(JSON.stringify(response));
          })
          .catch(error => {
              if (error.status !== 404) {
              console.log("ERROR", JSON.stringify(error));
            }
          });
      } 
    },

    createStaticFiles() {
      this.uploading = true;
      this.statusMessage = this.$t('sftp.uploadInProgress');
      this.showStatusMessage = true;
      let completePath = path + this.$route.params.tournamentId + "/staticResults"
      const localInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.sftpSettings,
        response: true,
      };
      let that = this;
      this.interval = setInterval(() => {
        this.getStaticStatus();
      }, 1000);
      RestAPI
        .post(apiName, completePath, localInit)
        .then(response => {
          console.log(response);
          that.uploading = false;
          clearInterval(that.interval); 
          that.$emit('ok');
        })
        .catch(error => {
          console.log("ERROR " +  JSON.stringify(error));
          that.errorMessage = error.response.data.message;
          that.uploading = false;
          clearInterval(that.interval); 
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },
  }
};


</script>

<style scoped>

button.disabled {
  cursor: default;
}

button.disabled:hover {
  cursor: default;
}

.statusMessage {
  white-space: pre-wrap;
}

/* mobile */
@media screen and (max-width: 600px) {
  button {
    margin: 3vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  button {
    margin: 2vw;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  button {
    margin: 1vw;
  }
}
</style>
